import { Text, Heading, Button, Img } from "./..";
import React from "react";

export default function UserInterfaceComponent({
  headingText = "End to End Solution",
  descriptionText =
    "Right from individual machine efficiency to order tracking and process optimization. No need for multiple disconnected solutions, which means all data flows smoothly to inform your decisions.",
  ...props
}) {
  return (
    <div
      {...props}
      className={`${props.className} flex flex-col items-center w-full sm:w-full md:w-[32%] px-5 py-4 bg-gradient2 rounded-lg televisioncolumn_border`}
    >
      <Button
        color="blue_A200"
        size="5xl"
        className="mt-[26px] w-[60px] rounded-[5px] px-4"
      >
        <Img src="images/img_television.svg" />
      </Button>
      <Heading
        size="heading4xl"
        as="h5"
        className="mt-5 bg-gradient1 bg-clip-text text-[24px] font-bold text-transparent sm:text-[20px] sm:text-center"
      >
        {headingText}
      </Heading>
      <Text
        size="textxl"
        as="p"
        className="mt-3 w-[88%] text-[16px] font-normal leading-[26px] text-muted sm:w-full sm:text-[14px] sm:text-center sm:px-5"
      >
        {descriptionText}
      </Text>
    </div>
  );
}
